// extracted by mini-css-extract-plugin
export default {"modalCancel":"_24dgRVuP-d87puiW7SCvhr"};